import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ChangePassword.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ChangePassword.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/pages/ChangePassword.vue?vue&type=script&lang=js&
// module id = 347
// module chunks = 0